import SuggestionForm from "@/components/suggestions/SuggestionForm";
import SuggestionsInbox from "@/components/suggestions/SuggestionsInbox";
import Announcements from "@/components/suggestions/Announcements";

export default function SuggestionsTab({ api, isAdmin }) {
  return (
    <div data-testid="community-suggestions-tab">
      <Announcements api={api} isAdmin={isAdmin} />
      {isAdmin ? <SuggestionsInbox api={api} /> : <SuggestionForm api={api} />}
    </div>
  );
}
